import { useQuery } from "@tanstack/react-query";

import { IQuartzJobsOverview } from "../../../@types/admin/AdminQuartzJobs";
import { quartzJobsService } from "../../../services/admin";
import { ensureOk } from "../../../utils/ensureOk";
import { HttpError } from "../../../utils/HttpError";

export const quartzJobsOverviewKey = ["admin-quartz-jobs-overview"];

/**
 * The Scheduled Jobs overview — the page's one query.
 *
 * A snapshot goes stale quickly (next-fire times move, jobs start and
 * finish), so besides `refetchOnMount: "always"` (no Refresh button on admin
 * pages) it re-reads every minute while the page is open.
 */
export function useQuartzJobsOverview() {
  const { data, isLoading, isError, error, dataUpdatedAt } =
    useQuery<IQuartzJobsOverview>({
      queryKey: quartzJobsOverviewKey,
      queryFn: async () => ensureOk(await quartzJobsService.getOverview()),
      refetchOnMount: "always",
      // The API caches the snapshot for 15s per node; a minute here keeps a tab from re-walking the
      // job store needlessly while still catching the next fire times moving.
      refetchInterval: 60_000,
    });

  return {
    overview: data,
    isLoading,
    isError,
    status: error instanceof HttpError ? error.status : undefined,
    dataUpdatedAt,
  };
}
